import './index.styl'

export default {
  name: 'NotFoundModule',
  methods: {
    handleClickBackBtn() {
      window.location.replace(window.location.origin)
    }
  },
  render(h, context) {
    // window.document.title = '深互动'
    const openid = this.$storage.getItem('openid')
    if(!openid) return (<div></div>)
    return (
      <div class="not-found-module-page">
        <img src="https://image.wxopen.shenhudong.com/v4-wechat-fonted/static/icon/not-found-module.svg" alt="image" />
        <div class="desc">活动已被删除，请联系中心</div>
        <div class="btn-wrapper" onClick={this.handleClickBackBtn}>
          <span>返回</span>
        </div>
      </div>
    )
  }
}